<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
      fill="#052E37"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 10.6144 18.3381 12.4652 17.4214 14.2543C15.4335 14.9153 14 16.7902 14 19C14 19.1756 14.009 19.349 14.0267 19.5199C12.8855 21.0196 12 22 12 22C12 22 5 14.25 5 9ZM12 4C9.24 4 7 6.24 7 9C7 11.85 9.92 16.21 12 18.88C14.12 16.19 17 11.88 17 9C17 6.24 14.76 4 12 4Z"
      fill="#052E37"
    />
    <path
      d="M18.6875 23.5625V22.7813C17.7361 22.684 16.9444 22.3194 16.3125 21.6875C15.6806 21.0556 15.316 20.2639 15.2188 19.3125H14.4375V18.6875H15.2188C15.316 17.7361 15.6806 16.9444 16.3125 16.3125C16.9444 15.6806 17.7361 15.316 18.6875 15.2188V14.4375H19.3125V15.2188C20.2639 15.316 21.0556 15.6806 21.6875 16.3125C22.3194 16.9444 22.684 17.7361 22.7813 18.6875H23.5625V19.3125H22.7813C22.684 20.2639 22.3194 21.0556 21.6875 21.6875C21.0556 22.3194 20.2639 22.684 19.3125 22.7813V23.5625H18.6875ZM19 22.1667C19.8681 22.1667 20.6128 21.8559 21.2344 21.2344C21.8559 20.6128 22.1667 19.8681 22.1667 19C22.1667 18.1319 21.8559 17.3872 21.2344 16.7656C20.6128 16.1441 19.8681 15.8333 19 15.8333C18.1319 15.8333 17.3872 16.1441 16.7656 16.7656C16.1441 17.3872 15.8333 18.1319 15.8333 19C15.8333 19.8681 16.1441 20.6128 16.7656 21.2344C17.3872 21.8559 18.1319 22.1667 19 22.1667ZM19 20.5625C18.5625 20.5625 18.1927 20.4115 17.8906 20.1094C17.5885 19.8073 17.4375 19.4375 17.4375 19C17.4375 18.5625 17.5885 18.1927 17.8906 17.8906C18.1927 17.5885 18.5625 17.4375 19 17.4375C19.4375 17.4375 19.8073 17.5885 20.1094 17.8906C20.4115 18.1927 20.5625 18.5625 20.5625 19C20.5625 19.4375 20.4115 19.8073 20.1094 20.1094C19.8073 20.4115 19.4375 20.5625 19 20.5625ZM19 19.9375C19.2639 19.9375 19.4861 19.8472 19.6667 19.6667C19.8472 19.4861 19.9375 19.2639 19.9375 19C19.9375 18.7361 19.8472 18.5139 19.6667 18.3333C19.4861 18.1528 19.2639 18.0625 19 18.0625C18.7361 18.0625 18.5139 18.1528 18.3333 18.3333C18.1528 18.5139 18.0625 18.7361 18.0625 19C18.0625 19.2639 18.1528 19.4861 18.3333 19.6667C18.5139 19.8472 18.7361 19.9375 19 19.9375Z"
      fill="#052E37"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ZamgPinCoord',
});
</script>
